import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { EnumSiNoTodos, Tc } from '../../../core/_infrastructure/types/common';
import { EntidadAuditoraService } from './entidadauditora.service';
import { FilterSearchingRegEntidadAuditoraViewModel, RegEntidadAuditoraItemResultsViewModel, RegEntidadAuditoraItemViewModel } from './entidadauditora.types';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';

@Component({
    selector: 'app-entidadauditora-list',
    templateUrl: './entidadauditora-list.component.html',
})
export class EntidadAuditoraListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    resultEntidadAuditora: RegEntidadAuditoraItemResultsViewModel;
    listProvincia: Tc[];
    cols: any[];
    visibilitySpinner = false;
    public isCollapsed = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private entidadAuditoraService: EntidadAuditoraService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.globalService.getProvincias().subscribe(res => {
            this.listProvincia = res;
        });

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Nombre', header: 'Nombre Representante' },
            { field: 'Apellidos', header: 'Apellidos Representante' },
            { field: 'NIF', header: 'NIF/EORI Representante' },
            { field: 'RazonSocial', header: 'Razón Social' },
            { field: 'NIFRazonSocial', header: 'NIF Razón Social' },
            { field: 'IdProvinciaRazonSocialDescripcion', header: 'Provincia Razón Social' },
            { field: 'CodigoPostalRazonSocial', header: 'C.P. Razón Social' },
            { field: 'DireccionRazonSocial', header: 'Dirección Razón Social' },
            { field: 'LocalidadRazonSocial', header: 'Localidad Razón Social' },
            { field: 'NombrePersonaContacto', header: 'Nombre Persona Contacto' },
            { field: 'ApellidosPersonaContacto', header: 'Apellidos Persona Contacto' },
            { field: 'EmailPersonaContacto', header: 'Email Persona Contacto' },
            { field: 'Activa', header: 'Activa' },
        ];

        this.form = this.fb.group({
            Nombre: null,
            Apellidos: '',
            NIF: ['', CustomValidator.NIFValidator],
            RazonSocial: '',
            NIFRazonSocial: ['', CustomValidator.NIFValidator],
            IdProvinciaRazonSocial: null,
            LocalidadRazonSocial: '',
            NombrePersonaContacto: '',
            ApellidosPersonaContacto: '',
            Activa: EnumSiNoTodos.TODOS,
        });

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack() {
        if (
            this.entidadAuditoraService.currentFilter.Apellidos != '' ||
            this.entidadAuditoraService.currentFilter.ApellidosPersonaContacto != '' ||
            this.entidadAuditoraService.currentFilter.IdProvinciaRazonSocial != null ||
            this.entidadAuditoraService.currentFilter.LocalidadRazonSocial != '' ||
            this.entidadAuditoraService.currentFilter.NIF != '' ||
            this.entidadAuditoraService.currentFilter.NIFRazonSocial != '' ||
            this.entidadAuditoraService.currentFilter.Nombre != '' ||
            this.entidadAuditoraService.currentFilter.Activa != EnumSiNoTodos.TODOS ||
            this.entidadAuditoraService.currentFilter.NombrePersonaContacto != '' ||
            this.entidadAuditoraService.currentFilter.RazonSocial != ''
        ) {
            this.form.patchValue({
                Nombre: this.entidadAuditoraService.currentFilter.Nombre,
                Apellidos: this.entidadAuditoraService.currentFilter.Apellidos,
                NIF: this.entidadAuditoraService.currentFilter.NIF,
                RazonSocial: this.entidadAuditoraService.currentFilter.RazonSocial,
                NIFRazonSocial: this.entidadAuditoraService.currentFilter.NIFRazonSocial,
                IdProvinciaRazonSocial: this.entidadAuditoraService.currentFilter.IdProvinciaRazonSocial,
                LocalidadRazonSocial: this.entidadAuditoraService.currentFilter.LocalidadRazonSocial,
                NombrePersonaContacto: this.entidadAuditoraService.currentFilter.NombrePersonaContacto,
                ApellidosPersonaContacto: this.entidadAuditoraService.currentFilter.ApellidosPersonaContacto,
                Activa: this.entidadAuditoraService.currentFilter.Activa,
            });

            this.onSearchButton();
        }
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.entidadAuditoraService.currentFilter.Nombre = this.form.value.Nombre;
        this.entidadAuditoraService.currentFilter.Apellidos = this.form.value.Apellidos;
        this.entidadAuditoraService.currentFilter.NIF = this.form.value.NIF;

        this.entidadAuditoraService.currentFilter.RazonSocial = this.form.value.RazonSocial;
        this.entidadAuditoraService.currentFilter.NIFRazonSocial = this.form.value.NIFRazonSocial;
        this.entidadAuditoraService.currentFilter.IdProvinciaRazonSocial = this.form.value.IdProvinciaRazonSocial;
        this.entidadAuditoraService.currentFilter.LocalidadRazonSocial = this.form.value.LocalidadRazonSocial;
        this.entidadAuditoraService.currentFilter.Activa = this.form.value.Activa;
        this.entidadAuditoraService.currentFilter.NombrePersonaContacto = this.form.value.NombrePersonaContacto;
        this.entidadAuditoraService.currentFilter.ApellidosPersonaContacto = this.form.value.ApellidosPersonaContacto;
        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc = -1, orderBy = 'Nombre') {
        this.loading = true;

        let model: FilterSearchingRegEntidadAuditoraViewModel = this.CreateModel();

        model.PageNumber = pageNumber;
        model.Asc = asc;
        model.OrderBy = orderBy;

        this.entidadAuditoraService.postGetPagedByFilter(model).subscribe(res => {
            this.resultEntidadAuditora = res;
            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            Nombre: null,
            Apellidos: '',
            NIF: '',
            RazonSocial: '',
            NIFRazonSocial: '',
            IdProvinciaRazonSocial: null,
            LocalidadRazonSocial: '',
            NombrePersonaContacto: '',
            ApellidosPersonaContacto: '',
            Activa: EnumSiNoTodos.TODOS,
        });

        this.searchingButton = false;
        this.isCollapsed = false;
    }

    CreateModel() {
        let model: FilterSearchingRegEntidadAuditoraViewModel = new FilterSearchingRegEntidadAuditoraViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    onAdd() {
        this.router.navigate(['/mantenimiento/registros/entidadesauditoras/create']);
    }

    onEdit(item: RegEntidadAuditoraItemViewModel) {
        this.router.navigate(['/mantenimiento/registros/entidadesauditoras/edit', item.Id]);
    }

    //onDelete(item: RegEntidadAuditoraItemViewModel) {
    //    this.confirmationService.confirm({
    //        message: '¿Está seguro?',
    //        accept: () => {
    //            //Actual logic to perform a confirmation
    //            this.entidadAuditoraService.deleteEntidadAuditora(item.Id).subscribe(
    //                res => {
    //                    this.addSuccessMessage('Entidad Auditora eliminada correctamente');
    //                    this.onSearchButton();
    //                },
    //                error =>
    //                    this.addErrorMessage(
    //                        'Error al borrar la Entidad Auditora. Puede que no se pueda eliminar porque ha sido utilizado en alguna solicitud.',
    //                    ),
    //            );
    //        },
    //    });
    //}

    onExportExcel() {
        this.visibilitySpinner = true;

        this.entidadAuditoraService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }
}
